import { FilterSingleCheckbox } from '../baseInputTypes/FilterSingleCheckbox'

type Props = {}
export const CSQ = (props: Props) => {
  return <FilterSingleCheckbox label="CSQ" fieldPath="productInformation.CSQ" />
}
